module.exports = __webpack_public_path__ + "img/anchor-move.c5d0c2e3.png";